import FeatherIcon from 'feather-icons-react';
import { colours } from "../consts";

export const SENTIMENTS_THRESHOLD = 1/3;

export const DATE_FORMAT = "dd/MM/yyyy";

export const LIST_NULL_OPTION_VALUE = -1;

export const ADMIN_GROUP_NAME = 'admin';

export const CAMPAIGN_TYPE_OPTIONS = ["Customer support", "Sales", "Collections", "Retention", "Escalation", "Accounts", "Other", "Unknown"];
export const CAMPAIGN_DIRECTION = ["Inbound", "Outbound"];

export const PLAYLIST_FILTERS_OPTIONS = [
    "Snippets",
    "WOW moments",
    "High risk",
    "Great interactions",
    "Poor interactions",
    "Other"
];

export const PLAYLIST_FILTER_INFO_DESCRIPTIONS = {
    ["Snippets"]: "All bookmarks",
    ["WOW moments"]: "Exceptional moments such as great Agent engagement, Client satisfaction, call outcome, etc.",
    ["High risk"]: "Critical issues that require attention as soon as possible such as threats of cancellation or legal action.",
    ["Great interactions"]: "Interactions that model the general good practice expected in the call centre.",
    ["Poor interactions"]: "Interactions that model the general bad practice to avoid in the call centre.",
    ["Other"]: "Storage space for any unclassified snippets or if a suitable category does not exist. "
}

const getIcon = (icon) => <FeatherIcon icon={icon} style={{ marginBottom: "4px" }} size={28} />

export const SIDE_BAR_LINKS = [{
    to: "/",
    icon: getIcon("home"),
    name: "Analytics",
    linkedPages: []
}, {
    to: "/campaigns",
    icon: getIcon("message-square"),
    name: "Campaigns",
    linkedPages: ["/campaign"]
}, {
    to: "/playlists",
    icon: getIcon("play-circle"),
    name: "Playlists",
    linkedPages: []
}, {
    to: "/insights",
    icon: getIcon("loader" ),
    name: "Insights",
    linkedPages: ["/insight-phrases"]
}, {
    to: "/alerts",
    icon: getIcon("bell"),
    name: "Alerts",
    linkedPages: []
}, 
//  closed as per the sheet sprint 2
// {
//     to: "/organisation",
//     icon: getIcon("briefcase"),
//     name: "Manage Users"
// }
];

export const getBottomMenuItems = (isAdmin) => {
    const items = [{
        to: "",
        icon: getIcon("log-out"),
        name: " Log Out",
        signOut: true,
        linkedPages: []
    }];
    
    if(isAdmin) {
        items.unshift({
            to: "/companies",
            icon: getIcon("settings"),
            name: "Settings",
            linkedPages: ["/users", "/insight-admin", "/edit-company"]
        })
    }
    return items;
};

export const HEADER_MENU_OPTIONS = [{
    to: "/profile",
    icon: "user",
    name: "Profile"
}, {
    to: "/companies",
    icon: "settings",
    name: "Settings"
}, {
    to: "/support",
    icon: "headphones",
    name: "Support"
}, {
    signOut: true,
    icon: "log-out",
    name: "Log Out"
}];

export const THEME_MODES = {
    LIGHT: 'light',
    DARK: 'dark',
    HIGH_CONTRAST: 'highContrast',
    COLOR_VISION: 'colorVision'
}

// Define constants
export const FONT_SIZE_LEVELS = {
    MIN: -2,
    MAX: 2,
    STEP: 1,
    NORMAL: 0,
};

export const FONT_SIZE_ACTION = {
    NORMAL : 'Normal',
    INCREASE : 'Increase',
    DECREASE : 'Decrease'
}